import LegalDoc from "@/components/LegalDoc";
import { TERMS } from "@/data/legal";

export default function Terms() {
  return <LegalDoc doc={TERMS} crossLink={{ pre: "See also our", to: "/privacy", label: "Privacy Policy" }} />;
}
